import React from "react";
import { FaGamepad, FaCogs, FaRocket, FaHeartbeat } from "react-icons/fa";
import "../style/ServicesSection.css";

const platformSteps = [
  {
    id: "sviluppo-interno",
    icon: FaGamepad,
    title: "Produzione interna",
    description: "I giochi Kyros partono da prototipi nostri. Li portiamo sul sito quando possiamo spiegare cosa sono e a che punto stanno.",
    highlights: ["Prototipi Kyros", "Gameplay provabile", "Stato del gioco"]
  },
  {
    id: "launcher-kyros",
    icon: FaCogs,
    title: "Launcher e libreria",
    description: "Account, download e installazione stanno nello stesso flusso, così il giocatore sa dove ritrovare i giochi Kyros.",
    highlights: ["Account unico", "Libreria personale", "Installazione Windows"]
  },
  {
    id: "store-account",
    icon: FaRocket,
    title: "Store proprietario",
    description: "Lo Store serve i giochi Kyros: schede chiare, stato del prodotto, licenza account e supporto vicino al momento dell'acquisto.",
    highlights: ["Schede prodotto", "Licenze account", "Rimborsi chiari"]
  },
  {
    id: "community-loop",
    icon: FaHeartbeat,
    title: "Community e playtest",
    description: "Discord e test controllati servono a raccogliere problemi concreti prima di cambiare stato a un gioco.",
    highlights: ["Feedback mirato", "Build in prova", "Aggiornamenti"]
  }
];

export default function ServicesSection() {
  return (
    <section className="services-section">
      <div className="services-section__inner">
        <div className="services-section__header">
          <span className="services-section__eyebrow">Piattaforma Kyros</span>
          <h1>Come pubblichiamo i videogame autoprodotti Kyros</h1>
          <p>
            Kyros Games sviluppa, pubblica e supporta i propri titoli per Windows.
            Store, account e launcher servono a rendere chiaro dove scaricare, comprare
            o seguire ogni gioco, senza trasformare il sito in una vetrina generica.
          </p>
        </div>

        <div className="services-section__grid">
          {platformSteps.map(step => {
            const Icon = step.icon;
            return (
              <article key={step.title} id={step.id} className="services-card">
                <div className="services-card__glow" aria-hidden="true" />
                <div className="services-card__icon">
                  <Icon />
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <ul>
                  {step.highlights.map(point => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <div className="services-section__cta">
          <div>
            <h3>Vuoi seguire i giochi Kyros?</h3>
            <p>
              Controlla il catalogo, entra nello Store o scrivici se ti serve supporto.
              Gli aggiornamenti partono sempre dai giochi che stiamo producendo.
            </p>
          </div>
          <a className="services-section__button" href="/games">
            Vedi i giochi
          </a>
        </div>
      </div>
    </section>
  );
}
